module.exports = __webpack_public_path__ + "7ed2960a4e0c66f81403640469950328.png";


//////////////////
// WEBPACK FOOTER
// ../components/icon/svg/applestore.png
// module id = 409
// module chunks = 0